import React from 'react';
import intl from 'react-intl-universal';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'semantic-ui-react';

import { dismissImpersonationCode, generateImpersonationCode } from 'actions/impersonationActions';
import { selectImpersonation } from 'selectors/impersonationSelectors';
import { Global } from 'state/Global';

import classes from './AccountSupport.scss';
import ImpersonationCodeModal from './ImpersonationCodeModal';

export default function AccountSupport() {
  const dispatch = useDispatch();
  const impersonation = useSelector((state: Global) => selectImpersonation(state));
  return (
    <div className={classes.container}>
      <div className={classes.pane}>
        <div className={classes.contentContainer}>
          <div className={classes.paneTitle}>
            {intl.get('accountSupport')}
          </div>
          <div className={classes.paneBody}>
            <div className={classes.textContainer}>
              <div className={classes.descriptionContainer}>
                {intl.get('supportCodeDescription')}
              </div>
            </div>
            <div className={classes.buttonContainer}>
              <Button
                onClick={() => dispatch(generateImpersonationCode())}
                role="button"
                type="button"
              >
                {intl.get('supportCodeGenerateText')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      { ( impersonation && (impersonation.code || impersonation.error)) && 
        <ImpersonationCodeModal
          code={impersonation.code}
          error={impersonation.error}
          onClose={() => dispatch(dismissImpersonationCode())}
        />
      }
    </div>
  );
}
